import { Component } from '@angular/core';

@Component({
  selector: 'app-cta',
  standalone: true,
  templateUrl: './cta.html',
  styleUrl: './cta.scss',
})
export class CtaComponent {
  scrollToTalleres() {
    const el = document.getElementById('talleres');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  }
}
